import * as R from 'ramda'
import { combineReducers } from 'redux'
import { handleActions, createAction } from 'redux-actions'

import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { requestInfoActions } from '../payment'
import { getBidActions, getBidByIdActions } from '../lots/bid'

//

const removeCardActions = generateActions('paymentMethods/REMOVE_CARD')
export const clearPaymentMethods = createAction('paymentMethods/CLEAR')
export const setPaymentData = createAction('paymentMethods/SET_DATA', (field, value) => ({ field, value }))

export const removeUserPayment = createAction(
  API_CONST,
  userPaymentId => ({
    method: 'post',
    actions: removeCardActions,
    url: `auth/info/removeCard`,
    params: { userPaymentId }
  }),
  userPaymentId => ({ userPaymentId })
)

//

const extractMethods = (state, { payload: { payments = {} } }) => ({
  ...state,
  ...R.map(item => ({
    title: item.title,
    isConfirmed: item.data.length > 0,
    withVisual: item.data.filter(item => !!item.visual).length > 0,
    cards: item.data.map(item => item._id)
  }), payments)
})

const extractCards = (state, { payload: { payments = {} } }) => {
  const result = R.compose(
    R.mergeAll,
    R.values,
    R.map(R.compose(
      R.reduce((acc, item) => R.assoc(item._id, item.visual, acc), {}),
      R.propOr([], 'data')
    ))
  )(payments)

  return { ...state, ...result }
}

//

const methods = handleActions({
  [clearPaymentMethods]: () => ({}),
  [getBidActions[1]]: extractMethods,
  [getBidByIdActions[1]]: extractMethods,
  [requestInfoActions[1]]: extractMethods
}, {})

//

const cards = handleActions({
  [clearPaymentMethods]: () => ({}),
  [getBidActions[1]]: extractCards,
  [getBidByIdActions[1]]: extractCards,
  [requestInfoActions[1]]: extractCards,
  [removeCardActions[1]]: (state, { meta }) => R.omit([meta.userPaymentId], state)
}, {})

//

const dataInitial = {
  paymentMethod: null,
  userPaymentId: null
}

const data = handleActions({
  [clearPaymentMethods]: () => ({ ...dataInitial }),
  [setPaymentData]: (state, { payload }) => ({
    ...state,
    [payload.field]: payload.value || null
  })
}, dataInitial)

//

export default combineReducers({ methods, cards, data })



// WEBPACK FOOTER //
// ./src/store/reducers/paymentMethods/index.js